"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusInQuery = getStatusInQuery;
/**
 * Utility function that allow to query models with statuses defined via statusPrototype.
 *
 * @param {Model} model Model with statusPrototype method
 * @param {ModelStatus[] | undefined} statusIn Array of statuses to query
 * @param {string | undefined} [prefix] Optional prefix to attach in query
 * @return {ObjectLiteral | undefined} query to use in where / aggreagation stage
 */
function getStatusInQuery({ model, statusIn, prefix, }) {
    if (!statusIn || statusIn.length === 0) {
        return;
    }
    const queries = statusIn.map((status) => {
        const query = model.statusPrototype(status);
        return Object.entries(query).reduce((formattedQuery, [key, value]) => {
            // statusPrototype return Date | undefined values, but this function supports other values as well
            return {
                ...formattedQuery,
                [(prefix ? prefix + "." : "") + key]: value instanceof Date ? { $ne: null } : query[key],
            };
        }, {});
    });
    return statusIn.length === 1 ? { ...queries[0] } : { $or: queries };
}
//# sourceMappingURL=getStatusInQuery.js.map